import { Col, Container, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faInstagram, faLinkedinIn, faYoutube } from '@fortawesome/free-brands-svg-icons';

export default function Footer() {
  const baseStyles = "pt-3 footer-bg";

  return (
    <footer className={`${baseStyles}`}>
      <div>
        <Container>
          <Row>
            <Col
              sm={12}
              md={2}
              className="d-flex flex-column m-auto  align-items-md-start light-text-color"
            >
              <div className="margin-auto rounded">
                <img
                  src={"/images/Wheatbakes-Logo.svg"}
                  width={"100%"}
                  alt={"Wheat Bakes"}
                />
              </div>
              
              <div className="d-flex m-auto  justify-content-center py-5">
                <ul className="social-icons">
                  <li>
                    <a href="https://www.facebook.com/wheatbakes.organic/" target="_blank">
                      <FontAwesomeIcon icon={faFacebookF} />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/80821124/admin/dashboard/" target="_blank">
                      <FontAwesomeIcon icon={faLinkedinIn} />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/wheatbakes.organic" target="_blank">
                      <FontAwesomeIcon icon={faInstagram} />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/@WheatBakes.Natural" target="_blank">
                      <FontAwesomeIcon icon={faYoutube} />
                    </a>
                  </li>
                </ul>
              </div>
            </Col>

            <Col className="py-4 light-text-color" sm={12} md={5}>
              <div>
                <h4 className="text-bold-600">Address</h4>
                <p className="text-bold-600 m-0">Pondy Bazaar</p>
                <p className="m-0">13/6, Thanikachalam Rd, T. Nagar, Chennai – 600017</p>
                <p className="text-bold-600  m-0">C.P.Ramasamy Road</p>
                <p className="m-0">77/17, C.P.Ramasamy Road, Alwarpet, Chennai - 600018</p>
              </div>
              <br></br>
              <div>
                <h4 className="text-bold-600">Opening Hours</h4>
                <div className="">All Days</div>
                <div className="">10:00 am – 11:00 pm</div>
              </div>
            </Col>

            <Col className="py-4 light-text-color" sm={12} md={5}>
              <div>
                <h4 className="text-bold-600">Quick Links</h4>
                <Row>
                  <Col xs={6} md={4}>
                    <p className="mb-0">
                      <a href="/home">Home</a>
                    </p>
                    <p className="mb-0">
                      <a href="/about-us">About Us</a>
                    </p>
                    <p className="mb-0">
                      <a href="/gallery">Gallery</a>
                    </p>  
                    <p className="mb-0">
                      <a href="/menu">Menu</a>
                    </p>   
                    <p className="mb-0">
                      <a href="/maida-free-cakes">Maida Free Cakes</a>
                    </p>      
                  </Col>

                  <Col xs={6} md={4}>                    
                    <p className="mb-0">
                      <a href="/blogs">Blogs</a>
                    </p>
                    <p className="mb-0">
                      <a href="/contact">Contact</a>
                    </p>   
                    <p className="mb-0">
                      <a href="/faq">FAQ</a>
                    </p>
                    <p className="mb-0">
                      <a href="/bulkorders">Bulk Orders</a>
                    </p>     
                      
                    <p className="mb-0">
                      <a href="/no-preservatives-natural">Natural Birthday Cakes</a>
                    </p>          
                  </Col>
                  <Col xs={6} md={4}>                    
                    <p className="mb-0">
                      <a href="/natural-bakery-chennai">Natural Bakery Chennai</a>
                    </p>    
                    <p className="mb-0">
                      <a href="/whole-wheat-cakes">Whole Wheat Cakes</a>
                    </p>                
                    
                  </Col>
                </Row>
              </div>
              <br></br>
              <div>
                <h4 className="text-bold-600">Contact</h4>
                <div className="">
                  
                  <a
                    className="cursor-pointer email-tag"
                    href="mailto:contact@wheatbakes.com"
                  ><FontAwesomeIcon icon={faEnvelope} />
                    contact@wheatbakes.com
                  </a>
                </div>
                <div className="">
                  
                  <a
                    className="cursor-pointer email-tag"
                    href="tel:+917904309386"
                  >
                    <FontAwesomeIcon icon={faPhone} />
                    +91 79043 09386
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="border-top pt-2 pb-2 light-text-color">
        <p
          style={{ textAlign: "center" }}
          className={` px-md-3 m-0 fw-normal fs-6 lh-lg`}
        >
          2025 © Wheat Bakes. All Rights Reserved. |{" "}
          <u>
            <a href="/privacy">Privacy & Policy</a>
          </u>
        </p>
      </div>
    </footer>
  );
}
